"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPerformanceObserver = require("../utilities/createPerformanceObserver");

var _performance = require("../utilities/performance");

var _getFirstHiddenTime = _interopRequireDefault(require("../utilities/getFirstHiddenTime"));

/**
 * This plugin is responsible for capturing the [Largest Contentful Paint][1].
 *
 * CAUTION: Web pages often load in stages, and as a result, it's possible that
 * the largest element on the page might change.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `largestContentfulPaint`: an important, user-centric metric for measuring
 *   perceived load speed because it marks the point in the page load timeline
 *   when the page's main content has likely loaded — a fast LCP helps reassure
 *   the user that the page is useful.
 *
 * This plugin won't send a beacon under the following circumstances to avoid
 * reporting meaningless results:
 *
 * - Since users can open pages in a background tab, it's possible LCP won't
 * happen until the user focuses the tab, which can be much later than when
 * they first loaded it.
 *
 * - Since LCP is based on heuristics, [values received after user input can
 * produce meaningless results][2].
 *
 * [1]: https://web.dev/lcp/
 * [2]: https://wicg.github.io/largest-contentful-paint/#limitations
 */
var createLargestContentfulPaintPlugin = function createLargestContentfulPaintPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;
    var observer;

    var finalize = function finalize() {
      window.removeEventListener('keydown', finalize, false);
      window.removeEventListener('scroll', finalize, false);
      window.removeEventListener('pointerdown', finalize, false);

      if (observer != null) {
        observer.takeRecords().forEach(function (entry) {
          if (entry.startTime < (0, _getFirstHiddenTime.default)()) {
            addVariable('largestContentfulPaint', entry.startTime, true);
          }
        });
        observer.disconnect();
      }

      sendBeacon();
    };

    try {
      observer = (0, _createPerformanceObserver.createPerformanceObserver)(_performance.EntryType.LARGEST_CONTENTFUL_PAINT, function (entry) {
        if (entry.startTime < (0, _getFirstHiddenTime.default)()) {
          addVariable('largestContentfulPaint', entry.startTime, true);
          sendBeacon();
        } else {
          finalize();
        }
      });
      window.addEventListener('keydown', finalize, false);
      window.addEventListener('scroll', finalize, false);
      window.addEventListener('pointerdown', finalize, false);
    } catch (error) {
      finalize();
    }
  };
};

var _default = createLargestContentfulPaintPlugin;
exports.default = _default;